import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

function parseDealData(el) {
  // Normaliser le nom du restaurant (vrai réponse API a storeName ou name selon la source)
  const restaurant = el.restaurant || {}
  const storeName = restaurant.storeName || restaurant.name || ''

  return {
    id: String(el.id || ''),
    restaurantId: String(el.restaurantId || ''),
    storeName,
    restaurant,
    targetType: String(el.targetType || 'delivery'),
    dishIds: el.dishIds || [],
    categoryIds: el.categoryIds || [],
    targetData: el.targetData || [],
    discountType: String(el.discountType || 'fixed'),
    discountValue: el.discountValue || 0,
    validFrom: el.validFrom || '',
    validUntil: el.validUntil || '',
    isActive: el.isActive ?? true,
    createdAt: el.createdAt || '',
    updatedAt: el.updatedAt || '',
    // Aliases pour compatibilité
    storeId: String(el.restaurantId || ''),
    discount: el.discountValue,
    startDate: el.validFrom,
    endDate: el.validUntil,
    status: (el.isActive !== false) ? 'active' : 'inactive',
  }
}

export default {
  url(payload) {
    if (payload?.id) {
      return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_DEALS_DETAILS, {
        pathParams: { id: payload.id }
      })
    }

    // Endpoint agrégé : retourne les deals avec restaurant et targetData déjà enrichis
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_DEALS_AGGREGATED, {
      queryParams: {
        restaurantId: payload?.restaurantId || undefined,
      }
    })
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to contact server',
        data: null,
      }
    }

    if (payload?.id) {
      return {
        statusCode: 200,
        message: 'Ok',
        data: raw.data ? parseDealData(raw.data) : null,
      }
    }

    // Réponse agrégée: { statusCode, message, data: [...] }
    const dealsData = Array.isArray(raw.data) ? raw.data : []

    // 1. Mapping des données
    let data = dealsData.map(parseDealData)

    // 2. Recherche textuelle locale
    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()

    if (searchTerm) {
      data = data.filter(el => {
        return (
          el.id.toLowerCase().includes(searchTerm) ||
          el.restaurantId.toLowerCase().includes(searchTerm) ||
          el.storeName.toLowerCase().includes(searchTerm) ||
          el.targetType.toLowerCase().includes(searchTerm) ||
          el.discountType.toLowerCase().includes(searchTerm) ||
          el.discountValue.toString().includes(searchTerm) ||
          el.status.toLowerCase().includes(searchTerm)
        )
      })
    }

    // 3. Tri dynamique
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      data = [...data].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') {
          return valA.localeCompare(valB) * order
        }
        if (typeof valA === 'number' && typeof valB === 'number') {
          return (valA - valB) * order
        }
        return 0
      })
    }

    // 4. Pagination
    const { page = 0, limit = 10000 } = payload || {}
    const paginated = searchTerm ? data : data.slice(page * limit, (page + 1) * limit)

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: data.length,
        result: paginated,
      },
    }
  },
}